/** Ids are declared `bigint` but hold strings at runtime (normalizeBigInt in
 *  packages/api), so an unset proto org arrives as the truthy "0" and neither a
 *  `??` nor a `||` chain falls through it. */
export const realOrgId = <T extends bigint | number | string>(id?: T | null): T | undefined =>
  id != null && String(id) !== "0" ? id : undefined;
